// we don't want to warn until react-dom@16.9.0 is actually released
export const reactDomSixteenPointNineIsReleased = false
